import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './deals-banner-small-logos-item.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var DealsBannerSmallLogosItem = /** @class */ (function (_super) {
    tslib_1.__extends(DealsBannerSmallLogosItem, _super);
    function DealsBannerSmallLogosItem(element) {
        var _this = _super.call(this, element) || this;
        _this.w = 1200;
        _this.h = 480; // initial height of the image
        _this.ratio = _this.w / _this.h;
        return _this;
    }
    DealsBannerSmallLogosItem.prototype.init = function () {
        this.imageHolder = this.element.querySelector('.deals-banner-small-logos-item__image-holder');
        this.desktopImages = Array.from(this.element.querySelectorAll('.deals-banner-small-logos-item__col-image__desktop'));
        this.tabletImages = Array.from(this.element.querySelectorAll('.deals-banner-small-logos-item__col-image__tablet'));
        this.mobileImages = Array.from(this.element.querySelectorAll('.deals-banner-small-logos-item__col-image__mobile'));
        this.contentBackground = this.element.querySelector('.deals-banner-small-logos-item__content-background');
        setTimeout(this.onResize.bind(this));
    };
    DealsBannerSmallLogosItem.prototype.bindEvents = function () {
        window.addEventListener('resize', this.onResize.bind(this));
    };
    DealsBannerSmallLogosItem.prototype.onResize = function () {
        if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
            this.desktopImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__show');
                item.classList.add('deals-banner-small-logos-item__col-image__hidden');
            });
            this.tabletImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__show');
                item.classList.add('deals-banner-small-logos-item__col-image__hidden');
            });
            this.mobileImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__hidden');
                item.classList.add('deals-banner-small-logos-item__col-image__show');
            });
        }
        else if (MediaQueryService.getMediaQuery() === 'medium-small' || MediaQueryService.getMediaQuery() === 'medium' || MediaQueryService.getMediaQuery() === 'large') {
            this.desktopImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__show');
                item.classList.add('deals-banner-small-logos-item__col-image__hidden');
            });
            this.tabletImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__hidden');
                item.classList.add('deals-banner-small-logos-item__col-image__show');
            });
            this.mobileImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__show');
                item.classList.add('deals-banner-small-logos-item__col-image__hidden');
            });
        }
        else {
            this.desktopImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__hidden');
                item.classList.add('deals-banner-small-logos-item__col-image__show');
            });
            this.tabletImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__show');
                item.classList.add('deals-banner-small-logos-item__col-image__hidden');
            });
            this.mobileImages.map(function (item) {
                item.classList.remove('deals-banner-small-logos-item__col-image__show');
                item.classList.add('deals-banner-small-logos-item__col-image__hidden');
            });
        }
        var ww = window.innerWidth;
        var el = this.element;
        el.style.opacity = '1';
        if (ww > this.w) {
            var bannerHeight = ww / this.ratio;
            var colWidth = this.w / 12;
            var cbWidth = ((ww - (12 * colWidth)) / 2) + (4 * colWidth);
            // this.imageHolder.style.height = bannerHeight + 'px';
            // this.contentBackground.style.width = cbWidth + 'px';
            // this.contentBackground.style.height = bannerHeight + 'px';
        }
        else {
            this.contentBackground.style.removeProperty('height');
            if (MediaQueryService.getMediaQuery() === 'x-small') {
                this.contentBackground.style.width = '100%';
                this.imageHolder.style.height = '122px';
            }
            else if (MediaQueryService.getMediaQuery() === 'small') {
                this.contentBackground.style.width = '100%';
                this.imageHolder.style.height = '250px';
            }
            else if (MediaQueryService.getMediaQuery() === 'medium') {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (5 * colWidth) + 'px';
            }
            else {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (4 * colWidth) + 'px';
            }
        }
    };
    return DealsBannerSmallLogosItem;
}(Base));
export { DealsBannerSmallLogosItem };



//////////////////
// WEBPACK FOOTER
// ./components/deals-banner-small-logos-item/deals-banner-small-logos-item.component.ts
// module id = 249
// module chunks = 0